<template>
  <div id="home">
    <el-container>
      <el-aside style="width:auto;height:100vh;background-color:#242424;overflow-x:hidden;"> <!--width="150px"-->
        <div v-if="noLogo==='0'">
          <div v-if="!isMenu" style="display:flex;height:5vh;width:100%;justify-content:center;align-items:center;">
            <div style="line-height:0.1;margin-top:0">
              <el-image :src="logo_url" style="color:#FBFCFE;"></el-image>
            </div>
          </div>
          <div v-else :style="{width:menu_w}"
               style="display:flex;height:5vh;justify-content:center;align-items:center;">
            <div style="line-height:0.1;margin-top:0">
              <el-image :src="logo_url1" style="color:#FBFCFE;height:20px;width:20px"></el-image>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="!isMenu" style="display:flex;height:5vh;width:100%;justify-content:center;align-items:center;">
            <div style="line-height:0.1;margin-top:0">
              <p style="color: #FFFFFF">{{ projectName }}</p>
            </div>
          </div>
          <div v-else :style="{width:menu_w}"
               style="display:flex;height:5vh;justify-content:center;align-items:center;">
            <div style="line-height:0.1;margin-top:0">
              <!--              <el-image :src="logo_url2" style="color:#FBFCFE;height:20px;width:20px"></el-image>-->
              <i class="el-icon-s-grid" style="color:#FFFFFF;font-size:20px;height:20px;margin-left:5px"></i>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <el-col :span="12">
          <el-menu
              :collapse="isMenu"
              :default-active=paths
              class="el-menu-vertical-demo"
              :style="{width:menu_w}"
              @open="handleOpen"
              @close="handleClose"
              background-color="#242424"
              text-color="#818181"
              active-text-color="#FBFCFE">
            <!--            <el-menu-item v-if="project==='hs'" index="/home/hsDataShow"-->
            <!--                          @click.native="handleSelectMenu('/home/hsDataShow')">-->
            <!--              <i class="home1" style="float:left;margin-top:20px;margin-right:10px"></i>-->
            <!--              <span slot="title">首页</span>-->
            <!--            </el-menu-item>-->
            <!--            <el-menu-item v-else index="/home/data" @click.native="handleSelectMenu('/home/data')">-->
            <!--              <i class="home1" style="float:left;margin-top:20px;margin-right:10px"></i>-->
            <!--              <span slot="title">首页</span>-->
            <!--            </el-menu-item>-->
            <el-submenu v-if="projectType==='2'" index="11"> <!-- 商品管理 -->
              <template slot="title">
                <i class="el-icon-bank-card"></i>
                <span slot="title">商品管理</span>
              </template>
              <el-menu-item index="/home/shopsUp" @click.native="handleSelectMenu('/home/shopsUp')">
                <span slot="title">出售中商品</span>
              </el-menu-item>
              <el-menu-item index="/home/shopsDown" @click.native="handleSelectMenu('/home/shopsDown')">
                <span slot="title">下架中商品</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu v-if="projectType==='2'" index="12"> <!-- 订单管理 -->
              <template slot="title">
                <i class="el-icon-bank-card"></i>
                <span slot="title">订单管理</span>
              </template>
              <el-menu-item index="/home/orderList" @click.native="handleSelectMenu('/home/orderList')">
                <span slot="title">订单列表</span>
              </el-menu-item>
              <el-menu-item index="/home/orderCount" @click.native="handleSelectMenu('/home/orderCount')">
                <span slot="title">订单统计</span>
              </el-menu-item>
              <el-menu-item index="/home/orderReview" @click.native="handleSelectMenu('/home/orderReview')">
                <span slot="title">财务对账统计</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu v-if="projectType==='2'" index="10"> <!-- 会所项目 -->
              <template slot="title">
                <i class="el-icon-bank-card"></i>
                <span slot="title">会所管理</span>
              </template>
              <el-menu-item index="/home/hsResvSet" @click.native="handleSelectMenu('/home/hsResvSet')">
                <span slot="title">预约设置</span>
              </el-menu-item>
              <el-menu-item index="/home/hsResvTxSet" @click.native="handleSelectMenu('/home/hsResvTxSet')">
                <span slot="title">预约通用设置</span>
              </el-menu-item>
              <el-menu-item index="/home/hsResvGl" @click.native="handleSelectMenu('/home/hsResvGl')">
                <span slot="title">预约管理</span>
              </el-menu-item>
              <el-menu-item index="/home/hsActivityGl" @click.native="handleSelectMenu('/home/hsActivityGl')">
                <span slot="title">活动管理</span>
              </el-menu-item>
              <el-menu-item index="/home/hsNoticeGl" @click.native="handleSelectMenu('/home/hsNoticeGl')">
                <span slot="title">公告管理</span>
              </el-menu-item>
              <el-menu-item index="/home/hsUserGl" @click.native="handleSelectMenu('/home/hsUserGl')">
                <span slot="title">用户管理</span>
              </el-menu-item>
              <el-menu-item index="/home/hsImgGl" @click.native="handleSelectMenu('/home/hsImgGl')">
                <span slot="title">轮播图管理</span>
              </el-menu-item>
              <el-menu-item index="/home/hsResvSeeGl" @click.native="handleSelectMenu('/home/hsResvSeeGl')">
                <span slot="title">参观预约管理</span>
              </el-menu-item>
              <el-menu-item index="/home/hsActivityEvaluate"
                            @click.native="handleSelectMenu('/home/hsActivityEvaluate')">
                <span slot="title">用户评价管理</span>
              </el-menu-item>
              <el-menu-item index="/home/hsAdvice" @click.native="handleSelectMenu('/home/hsAdvice')">
                <span slot="title">意见反馈管理</span>
              </el-menu-item>
            </el-submenu>  <!-- -------------- 会所项目end ---------------- -->
            <el-submenu index="2">
              <template slot="title">
                <i class="device" style="float:left;margin-top:20px;margin-right:10px"></i>
                <span slot="title">设备管理</span>
              </template>
              <!--              <el-menu-item index="/home/glDev" @click.native="handleSelectMenu('/home/glDev')">
                              <span slot="title">设备控制</span>
                            </el-menu-item>-->
              <el-menu-item index="/home/glDevList" @click.native="handleSelectMenu('/home/glDevList')">
                <span slot="title">设备控制</span>
              </el-menu-item>
              <el-menu-item v-if="isDb" index="/home/ctrDb"
                            @click.native="handleSelectMenu('/home/ctrDb')">
                <span slot="title">电表列表</span>
              </el-menu-item>
              <el-menu-item v-if="projectType!=='2'" index="/home/glDevSonLd"
                            @click.native="handleSelectMenu('/home/glDevSonLd')">
                <span slot="title">人体传感</span>
              </el-menu-item>
              <!--              <el-menu-item v-if="isVirtual" index="/home/glDevSonTemp"-->
              <!--                            @click.native="handleSelectMenu('/home/glDevSonTemp')">-->
              <!--                <span slot="title">温湿度计</span>-->
              <!--              </el-menu-item>-->
              <!--              <el-menu-item v-if="isVirtual" index="/home/glDevSonAir"-->
              <!--                            @click.native="handleSelectMenu('/home/glDevSonAir')">-->
              <!--                <span slot="title">空气质量</span>-->
              <!--              </el-menu-item>-->
              <el-menu-item index="/home/glDevErr" @click.native="handleSelectMenu('/home/glDevErr')">
                <span slot="title">故障列表</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-office-building" style="float:left;margin-top:20px;margin-right:10px"></i>
                <span slot="title">区域管理</span>
              </template>
              <el-menu-item index="/home/glArea" @click.native="handleSelectMenu('/home/glArea')">
                <span slot="title">区域管理</span>
              </el-menu-item>
              <el-menu-item index="/home/glAreaGrp" @click.native="handleSelectMenu('/home/glAreaGrp')">
                <span slot="title">区域分组</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="/home/glHouse" @click.native.stop="handleSelectMenu('/home/glHouse')">
              <i v-if="isMenu" class="el-icon-school" style="float:left;margin-top:20px;margin-right:20px"></i>
              <i v-else class="el-icon-school" style="float:left;margin-top:20px;margin-right:10px"></i>
              房屋管理
            </el-menu-item>
            <el-menu-item index="/home/scene" @click.native.stop="handleSelectMenu('/home/scene')">
              <i v-if="isMenu" class="el-icon-menu" style="float:left;margin-top:20px;margin-right:20px"></i>
              <i v-else class="el-icon-menu" style="float:left;margin-top:20px;margin-right:10px"></i>
              场景策略
            </el-menu-item>
            <el-menu-item index="/home/timing" @click.native.stop="handleSelectMenu('/home/timing')">
              <i v-if="isMenu" class="el-icon-time" style="float:left;margin-top:20px;margin-right:20px"></i>
              <i v-else class="el-icon-time" style="float:left;margin-top:20px;margin-right:10px"></i>
              定时策略
            </el-menu-item>
            <el-submenu index="4">
              <template slot="title">
                <i class="energy" style="float:left;margin-top:20px;margin-right:10px"></i>
                <span>联动策略</span>
              </template>
              <el-menu-item index="/home/sceneTlink" @click.native.stop="handleSelectMenu('/home/sceneTlink')">
                联动管理
              </el-menu-item>
              <el-menu-item index="/home/tlinkTjcf" @click.native.stop="handleSelectMenu('/home/tlinkTjcf')">
                触发条件
              </el-menu-item>
              <el-menu-item index="/home/tlinkTjys" @click.native.stop="handleSelectMenu('/home/tlinkTjys')">
                约束条件
              </el-menu-item>
              <el-menu-item index="/home/tlinkTjtime" @click.native.stop="handleSelectMenu('/home/tlinkTjtime')">
                例外时段
              </el-menu-item>
            </el-submenu>
            <!--            <el-submenu v-if="isBle!=='1'" index="5">
                          <template slot="title">
                            <i class="Statistics" style="float:left;margin-top:20px;margin-right:10px"></i>
                            <span>节能统计</span>
                          </template>
                          <el-menu-item index="/home/glDb" @click.native="handleSelectMenu('/home/glDb')">
                            <span slot="title">电表分组</span>
                          </el-menu-item>
                          <el-menu-item index="/home/dataEnergy" @click.native="handleSelectMenu('/home/dataEnergy')">
                            <span slot="title">能耗统计</span>
                          </el-menu-item>
                        </el-submenu>-->
            <el-submenu index="6">
              <template slot="title">
                <i class="set" style="float:left;margin-top:20px;margin-right:10px"></i>
                <span>管理设置</span>
              </template>
              <el-menu-item index="/home/glWx" @click.native="handleSelectMenu('/home/glWx')">
                <span slot="title">小程序管理</span>
              </el-menu-item>
              <el-menu-item index="/home/glUser" @click.native="handleSelectMenu('/home/glUser')">
                <span slot="title">人员管理</span>
              </el-menu-item>
              <el-menu-item index="/home/log" @click.native.stop="handleSelectMenu('/home/log')">
                <span slot="title">日志管理</span>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
      </el-aside>
      <el-container>
        <el-header class="home_header" style="height: 5vh">
          <div style="display:flex;align-items:center;height:5vh">
            <el-tooltip class="item" effect="dark" :content="this.menu_name" placement="bottom">
              <i v-if="this.menu_name==='展开'" @click="isTab" class="el-icon-s-unfold"
                 style="font-size:25px;margin-left:15px"></i>
              <i v-else @click="isTab" class="el-icon-s-fold" style="font-size:25px;margin-left:15px"></i>
            </el-tooltip>
            <i class="el-icon-search" style="margin-left:auto;font-size:17px;margin-right:15px"></i>
            <i class="el-icon-bell" style="font-size:17px;margin-right:15px"></i>
            <el-dropdown @command="handleCommand" @visible-change="change_usxl($event)"
                         style="margin-left:5px;margin-right:15px; color: #000000; font-size: 15px">
              <span class="el-dropdown-link" style="margin-left: auto;margin-right:15px">
                 <i class="el-icon-user" style="font-size:20px;margin-right:3px"></i>
                 {{ usrName }}
                 <el-dropdown-menu slot="dropdown">
                   <el-dropdown-item command="usr_gmm">修改密码</el-dropdown-item>
                   <!--                   <el-dropdown-item command="usr_name">修改名称</el-dropdown-item>-->
                   <el-dropdown-item command="usr_tc">退出登录</el-dropdown-item>
                 </el-dropdown-menu>
              </span>
            </el-dropdown>
          </div>
        </el-header>
        <el-main class="el-main">
          <router-view @updateData="upHoneTab"></router-view>
        </el-main>
      </el-container>
      <el-dialog title='修改密码' center :close-on-click-modal="false"
                 width="360px" height="600px" class="data-dialog"
                 style="-moz-user-select: none;user-select: none; font-size: inherit;"
                 :visible.sync='dailogShowmm'> <!--v-draggable 拖动-->
        <div style="margin-top:0;">
          <span>用户名：</span>
          <el-input placeholder="用户名" style="width:200px;height:30px;font-weight:600;color:#000000"
                    v-model="userName" disabled></el-input>
        </div>
        <div style="margin-top:20px;">
          <span>旧密码：</span>
          <el-input placeholder="旧密码" style="width:200px;height:30px;" v-model="pswd_lod"></el-input>
        </div>
        <div style="margin-top:20px;">
          <span>新密码：</span>
          <el-input placeholder="新密码" style="width:200px;height:30px;" v-model="pswd_new"></el-input>
        </div>
        <div style="margin-top:30px;display: flex">
          <el-button @click="dialog_Onclick('退出')" style="margin-left:auto;">退出
          </el-button>
          <el-button @click="dialog_Onclick('保存')" type="primary" style="margin-right:15px">保存
          </el-button>
        </div>
      </el-dialog>
      <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="30%">
        <span>您确认要退出吗？</span>
        <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onTc">确 定</el-button>
      </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>

import CryptoJS from "crypto-js";

export default {
  name:'home',
  data() {
    return {
      isBle:"0",
      isDb:0, /*美斯玛电表界面*/
      noLogo:"0",
      isMenu:false,
      menu_w:"200px",
      menu_name:"收起",
      is_img:false,
      projectName:localStorage.getItem("projectName"),
      logo_url:require('@/assets/logo1.png'),
      logo_url1:require('@/assets/logo.png'),
      logo_url2:require('@/assets/data_2.png'),
      selectedFile:null,
      Height:100,
      maxHeight:window.innerHeight - 136,
      sites:[
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13
      ],
      d_type:"",
      usr_name:"",
      unit_name:"",
      kt_unit:0,
      daiTitle:"区域管理",
      daiTName:"区域信息",
      daiArea:false,
      daiChangeArea:false,
      daiChangeName:false,
      tableData:[],
      edi_area:"",
      edi_area1:"",
      li_area:[],
      edi_build:"",
      edi_build1:"", /*顶部搜索栏*/
      li_build:[],
      d_name:"",
      d_left:"",
      d_top:"",
      d_bz:"",
      img_url:"",
      dev_name:"区域名称",
      dev_bz:"备注",
      addName:"添加区域",
      defHead:[
        {'key':"编号",'val':"uptime"},
        {'key':"区域名称",'val':"ctr_type"},
        {'key':"备注",'val':"set_type"}
      ],
      is_dl:true, /*判断电量界面显示*/
      kt_qx:true,
      cz_pwr:0,
      gs_id:1,
      paths:this.$route.path,
      isCollapse:true,
      activeMenu:"",
      usrName:"账号名称",
      usr_icon:true,
      dialogVisible:false,
      dailogShowmm:false,
      dailog_name:false,
      userName:localStorage.getItem("username"),
      pswd_lod:"",
      pswd_new:"",
      dailog_qxbg:"#283A4D",
      dailog_qdbg:"#283A4D",
      isVirtual:true,
      projectType:"1",
      projectId:"0"
    };
  },
  methods:{
    upHoneTab(newData) {   // 子页面更新父组件的数据
      console.log('-------------upHoneTab-------------',newData);
      if ("isVirtual" in newData) {
        this.isVirtual = newData["isVirtual"];
      }
    },
    handleSelectMenu(path) { /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    handleOpen(key,keyPath) { /*左侧导航栏收起/关闭*/
      console.log(key,keyPath);
    },
    handleClose(key,keyPath) {
      console.log(key,keyPath);
    },
    isTab() {
      if (this.isMenu) {
        this.menu_w = "200px";
        this.isMenu = false;
        this.menu_name = "收起";
      } else {
        this.menu_w = "60px";
        this.isMenu = true;
        this.menu_name = "展开";
      }
    },
    change_usxl(callback) { /*修改用户名称旁边图标*/
      this.usr_icon = !callback;
    },
    onTc() { /*退出登录*/
      // localStorage.clear() /*清除缓存账号密码*/
      localStorage.setItem("password","");
      this.$router.replace({path:'/'}); /*单向路由跳转-跳转后清空之前路由*/
      // location.reload()
    },
    change_pswd() {
      const params = {
        'userName':this.userName,
        'password':CryptoJS.MD5(this.pswd_lod).toString(),
        'newPassword':CryptoJS.MD5(this.pswd_new).toString(),
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.changePassword,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.dailogShowmm = false;
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("修改失败");
        }
      });
    },
    dialog_Onclick(v) {
      switch (v) {
        case "保存":
          if (this.usrName === null || this.usrName.length < 1) {
            this.$message.error('请先输入用户名');
          } else if (this.pswd_lod === null || this.pswd_lod.length < 1) {
            this.$message.error('请先输入旧密码');
          } else if (this.pswd_new === null || this.pswd_new.length < 1) {
            this.$message.error('请先输入新密码');
          } else {
            this.change_pswd();
          }
          break;
        case "退出":
          clearTimeout(this.timer_wd);  //按钮高亮3毫秒变回
          this.timer_wd = setTimeout(() => {
            this.dailog_qxbg = '#283A4D';
          },300);
          this.dailogShowmm = false; /*将dialog关闭*/
          break;
      }
    },
    handleCommand(command) { /*用户登录下拉框*/
      if (command === "usr_tc") { /*退出*/
        this.dialogVisible = true;
      } else if (command === "usr_gmm") { /*修改密码*/
        this.dailogShowmm = true;
      } else if (command === "usr_name") { /*修改名称*/
        this.dailog_name = true;
      }
    },
    getDev() {
      const params = {
        'page':1,
        'pageSize':30,
        'projectId':localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getDeviceList,params,headers).then(res => {
        console.log("所有设备状态",res.data.data);
        this.li_dev = res.data.data["list"];
        if (this.li_dev.some(item => item.pid.includes("pir_gather"))) {
          this.isVirtual = true; // 雷达
        }
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    get_projectInfo() {
      const params = {
        "projectId":this.projectId
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log("projectId",this.projectId);
      this.$api.post(this.$urls.ip + this.$urls.getProjectInfo,params,headers).then(res => {
        console.log("项目信息，",res.data.data);
        let d = res.data.data;
        if (d.isBle) {
          this.isBle = "1";
          localStorage.setItem("isBle","1");
        } else {
          this.isBle = "0";
          localStorage.setItem("isBle","0");
        }
        this.projectType = "" + d.type;
        localStorage.setItem("projectType","" + d.type); /*1、通用项目 2、会所*/
      }).catch(error => {
        console.log(error);
        if (error) {
          this.$message.error("获取项目信息失败");
        }
      });
    },
    get_ip() {
      this.$api.get("ipConfig.json")  /*替换全局ip*/
          .then(res => {
        console.log(res.data);
        console.log("免登录",res.data["noLogin"]);
        if (res.data["noLogin"] === true) {
          this.$urls.ip = res.data["baseUrl"];
          this.$urls.websocketUrl = res.data["websocketUrl"];
          this.projectId = res.data["projectId"];
          this.noLogo = res.data["name"];
          localStorage.setItem("srv_ip",this.$urls.ip);
          localStorage.setItem("projectId",this.$urls.projectId);
          localStorage.setItem("websocketUrl",this.$urls.websocketUrl);
          localStorage.setItem("noLogo","" + res.data["name"]);
        } else {
          this.$urls.ip = localStorage.getItem("srv_ip");
          this.$urls.websocketUrl = localStorage.getItem("websocketUrl");
          this.isBle = localStorage.getItem("isBle");
          this.projectType = localStorage.getItem("projectType");
          this.projectId = localStorage.getItem("projectId");
        }
        this.get_projectInfo();
      }).catch(error => {
        console.log(error);
      });
    }
  },
  mounted() { /*页面加载时调用*/
    this.get_ip();
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.noLogo = localStorage.getItem("noLogo");
    // this.projectType = localStorage.getItem("project");
    // this.$urls.websocketUrl = localStorage.getItem("websocketUrl");
    // this.isBle = localStorage.getItem("isBle");
    if (this.$urls.ip) {
      console.log(this.$route.path);
      document.title = "管理平台";
      if (this.$route.path === "/home") { /*判断表格未点击过场景*/
        this.paths = "/home/glDevList";
      }
      this.usrName = localStorage.getItem("nickName");
      if (parseInt(localStorage.getItem("kt_qx")) !== 0) {
        this.kt_qx = false;
      }
      this.getDev();
    } else {
      setTimeout(() => {
        console.log(this.$route.path);
        document.title = "管理平台";
        if (this.$route.path === "/home") { /*判断表格未点击过场景*/
          this.paths = "/home/glDevList";
        }
        this.usrName = localStorage.getItem("nickName");
        if (parseInt(localStorage.getItem("kt_qx")) !== 0) {
          this.kt_qx = false;
        }
        this.getDev();
      },200);
    }
  },
  watch:{ /*监听路由，更新activeMenu*/
    '$route':function (to) {
      this.paths = to.path;
    }
  }
};
</script>


<style>
@import '../assets/css/icon_self.css';

#home {
  margin: 0;
  padding: 0;
}

.home_header {
  height: 5vh;
  background-color: #FFFFFF;
  color: #333;
  text-align: center;
  padding: 0;
  margin: 0;
}

.data-dialog {
  .el-dialog__title {
    color: #000000;
    font-weight: 900;
  }

  .el-dialog__header {
    color: #000000;
    background: #FFFFFF;
  }

  .el-dialog__body {
    color: #000000;
    background: #FFFFFF;
  }
}

.el-main {
  height: 100%;
  background-color: #E9EEF3;
  color: #333;
  padding: 0; /*内边距*/
  margin: 0; /*外边距*/
}

.grid-box-home { /*表格式布局*/
  display: grid;
  overflow-y: auto;
  grid-template-columns: repeat(auto-fill, 160px);
  grid-auto-flow: row; /*改为先列后行 column*/
  column-gap: 10px; /*行列间距*/
  row-gap: 10px;
  height: 330px;
  margin-top: 10px;
  /*grid-template-rows: repeat(auto-fill, 300px); !*设置高度限制*!*/
  /*justify-content: center; align-content: center; !*居中显示*!*/
}

.grid-item-home {
  height: 100px;
  background: #283A4D;
  color: #ffffff;
  /*font-size: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;*/
}

.grid-box-home::-webkit-scrollbar {
  width: 6px;
}

.grid-box-home::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #0dA7C8;
}

.grid-box-home::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #0dA7C8;
}

::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: #cacaca;
  border: 1px solid #cacaca;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
//  position: fixed; //  top: 80px; //  right: 0; //  bottom: 0; //  left: 0;
}

.el-menu-vertical-demo::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.el-divider--horizontal { /*分割线样式*/
  margin: 0px 0% 0% 0%; /*上 右 下 左*/
  width: 100%;
  background: #F2F2F2;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue